var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "order-progress",
      class: {
        "order-progress--agency": _vm.step == 2,
        "order-progress--booking": _vm.step >= 3
      }
    },
    [
      _c("div", { staticClass: "order-progress__wrapper" }, [
        _c(
          "div",
          { staticClass: "order-progress__steps" },
          [
            _vm._l(_vm.steps, function(itemStep, stepKey) {
              return _c(
                "div",
                {
                  key: stepKey,
                  staticClass: "order-progress-item",
                  class: {
                    "order-progress-item--filled": stepKey < _vm.step,
                    "order-progress-item--current": _vm.step == stepKey
                  }
                },
                [
                  _c("span", {
                    staticClass: "order-progress-item__text",
                    domProps: { textContent: _vm._s(itemStep) }
                  })
                ]
              )
            }),
            _vm._v(" "),
            _vm._m(0)
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order-progress-bar" }, [
      _c("div", { staticClass: "order-progress-bar__fill" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ee534cba", { render: render, staticRenderFns: staticRenderFns })
  }
}